module.exports = __webpack_public_path__ + "static/media/48_Print.5f2c2ce8.png";